import React from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card } from 'react-bootstrap';

const GlobalFilter = ({ filter, setFilter }) => (
  <input
    value={filter || ''}
    onChange={(e) => setFilter(e.target.value)}
    placeholder="Search..."
    className="form-control"
  />
);

const Stocktable = ({ columns, data, Debitdata, Creditdata, openingBalance, totalCredit, closingBalance }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    state,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter
  );

  const { globalFilter } = state;

  return (
    <Card>
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Account Ledger</h5>
          <div style={{ width: '220px' }}>
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <table {...getTableProps()} className="table datanew">
            <thead className='bg-dark' style={{ backgroundColor: 'black' }} >
              {headerGroups.map((headerGroup) => (
                <tr className="thead-dark" {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} style={{
                      position: 'sticky',
                      top: 0,
                      zIndex: 3,
                      backgroundColor: 'black',
                      color: 'white',
                    }}>{column.render('Header')}</th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr className='bg-secondary' style={{
                position: 'sticky',
                bottom: 0,
                zIndex: 3,
                backgroundColor: 'black',
                color: 'white',
                borderTop:"none",
              }}>
                <td colSpan={5} className="fw-bold text-success"></td>
                <td className="fw-bold text-danger">DR {Debitdata}</td>
                <td className="fw-bold text-success">CR {Creditdata}</td>
                <td className="fw-bold text-success">{closingBalance}</td>
              </tr>
            </tfoot>

          </table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Stocktable;
